import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import { style } from '../../../components/pdf/fontstyles';
import { AutoText } from '../../../components/pdf/autoText';
import { m } from 'framer-motion';


const styles = StyleSheet.create({
  page: {
    padding: 40,
    marginLeft: 20,
    fontSize: 10,
    lineHeight: 1.5,
    ...style.marathi,
  },
  title: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 5,
    textAlign: 'center',
    ...style.marathi,
  },
  subTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    marginTop: 15,
    marginBottom: 10,
    textAlign: 'center',
    ...style.marathi,
  },
  paragraph: {
    fontSize: 12,
    marginBottom: 15,
    textAlign: 'justify',
    ...style.marathi,
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    marginTop: 20,
    marginBottom: 30,
  },
  tableRow: {
    margin: 'auto',
    flexDirection: 'row',
  },
  tableColHeader: {
    width: '25%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: '#f0f0f0',
    padding: 5,
  },
  tableCol: {
    width: '25%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 5,
  },
  headerText: {
    fontWeight: 'bold',
    textAlign: 'center',
  },
  signature: {
    marginTop: 40,
    textAlign: 'right',
    marginRight: 100,
    ...style.marathi,
  },
  line: {
    borderBottomWidth: 1,
    borderBottomColor: '#000',
    marginTop: 2,
    width: 200,
    marginLeft: 'auto',
  },
});

const Namuna22 = ({ result }) => {
  const toMarathiDigits = str => str.replace(/\d/g, d => '०१२३४५६७८९'[d]);
const dateOfRetirement = toMarathiDigits(result.dateOfRetirement);
const dateOfAppointment = toMarathiDigits(result.dateOfAppointment);

  return(
    <View size="A4" style={styles.page}>
      {/* Header Section */}
      <Text style={styles.title}>नमुना २२</Text>
      <Text style={styles.title}>(नियम ५९ (१) पहा)</Text>
      <Text style={[styles.subTitle, { fontSize: 18 }]}>निवृत्तीवेतनासाठी सेवा पडताळणी प्रमाणपत्राचा नमुना</Text>

      {/* Main Content */}
      <Text style={[styles.paragraph, style.marathi, { marginTop: 20 }]}>
        असे प्रमाणित करण्यात येते की, {result.employeeNameMar}, {result.designationMar},{result.institutionNameMar}, यांनी खाली दिलेल्या तपशीलाप्रमाणे । {dateOfRetirement} रोजी 19 वर्षे 8 महिने 0 दिवस एवढी अर्हताकारी सेवा पूर्ण केलेली आहे. त्यांच्या सेवा विषय कागदपत्राच्या आधारे आणि अर्हताकरी सेवेबाबत सध्या अमलात असलेल्या नियमानुसार सेवेची पडताळणी केलेली आहे, महाराष्ट्र नागरी सेवा (निवृत्ती वेतन) नियम १९८२ मधील नियम ५९ च्या पोटनियम (१) व (२) अन्वये केलेली पडताळणी अंतिम समजली जाईल आणि निवृत्ती वेतनासाठी अर्हताकारी ठरवणाऱ्या सेवाविषयक शर्तीना लागू होणाऱ्या नियमामध्ये व आदेशामध्ये मागाहून होणाऱ्या बदलामुळे आवश्यक असल्याखेरीज अशी पडताळणी पुन्हा करण्यात येणार नाही.
      </Text>

      <Text style={styles.subTitle}>अर्हताकारी सेवेचा तपशील</Text>

      {/* Table Section */}
      <View style={styles.table}>
        {/* Table Header */}
        <View style={styles.tableRow}>
          <View style={styles.tableColHeader}>
            <Text style={styles.headerText}>अ.क्र.</Text>
          </View>
          <View style={styles.tableColHeader}>
            <Text style={styles.headerText}>पासून</Text>
          </View>
          <View style={styles.tableColHeader}>
            <Text style={styles.headerText}>पर्यंत</Text>
          </View>
          <View style={styles.tableColHeader}>
            <Text style={styles.headerText}>पद</Text>
          </View>
        </View>
        
        {/* Table Row */}
        <View style={styles.tableRow}>
          <View style={styles.tableCol}>
            <Text>१</Text>
          </View>
          <View style={styles.tableCol}>
            <Text>{dateOfAppointment}</Text>
          </View>
          <View style={styles.tableCol}>
            <Text>{dateOfRetirement}</Text>
          </View>
          <View style={styles.tableCol}>
            <Text>{result.designationMar}</Text>
          </View>
        </View>
      </View>

      {/* Signature Section */}
      <View style={styles.signature}>
        <Text>प्राचार्य</Text>
      </View>
    </View>
);
};
export default Namuna22;